import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material"
import {createContext, ReactNode, useState} from "react"

type ConfirmationCallback = () => void  | (() => Promise<void>)

export type ConfirmActionOptionsType = {
    askConfirmation: (onConfirm: ConfirmationCallback, title?: ReactNode, message?: ReactNode) => void
}

const defaultProvider: ConfirmActionOptionsType = {
    askConfirmation: () => null
}

const ConfirmActionContext = createContext(defaultProvider)

type PromiseResolveReject = {
    resolve: () => void;
    reject: () => void;
}

const ConfirmActionProvider = ({ children }: { children: React.ReactNode }) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<React.ReactNode>();
    const [dialogMessage, setDialogMessage] = useState<React.ReactNode>();
    const [onConfirmCallback, setOnConfirmCallback] = useState<() => void>(() => { console.log('callback') });

    const [promiseResolveReject, setPromiseResolveReject] = useState<PromiseResolveReject | null>(null);

    function isPromise(value: any): value is Promise<void> {
        return value && typeof value.then === 'function';
    }

    // const askConfirmation = (onConfirm: ConfirmationCallback, message?: React.ReactNode) => {
    //     setOnConfirmCallback(() => onConfirm);
    //     message && setDialogMessage(message);
    //     setOpenDialog(true);
    // }

    const askConfirmation = (onConfirm: ConfirmationCallback, title?: ReactNode, message?: ReactNode): Promise<void> => {
        return new Promise((resolve, reject) => {
            setOnConfirmCallback(() => onConfirm);
            setPromiseResolveReject({ resolve, reject });
            title && setDialogTitle(title);
            message && setDialogMessage(message);
            setOpenDialog(true);
        });
    }

    const handleConfirm = async () => {
        if (onConfirmCallback) {
            const result = onConfirmCallback();
            if (isPromise(result)) {
                await result;
            }
            if (promiseResolveReject) {
                promiseResolveReject.resolve();
            }
        }
        setOpenDialog(false);
        setDialogMessage(undefined);
    }

    const handleCancel = () => {
        if (promiseResolveReject) {
            promiseResolveReject.reject();
        }
        setOpenDialog(false);
        setDialogMessage(undefined);
    }

    return (
        <ConfirmActionContext.Provider value={{ askConfirmation }}>
            {
                openDialog &&
                <Dialog open={openDialog} fullWidth maxWidth='xs'>
                    <DialogTitle>
                        {
                            dialogTitle || "¿Está seguro que desea realizar esta acción?"
                        }
                    </DialogTitle>
                    <DialogContent>
                        {/*<DialogContentText>*/}
                            { dialogMessage }
                        {/*</DialogContentText>*/}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='text'
                            color='primary'
                            onClick={handleCancel}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={handleConfirm}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            {children}
        </ConfirmActionContext.Provider>
    )
}

export { ConfirmActionContext, ConfirmActionProvider }

